// 关于我们管理
import http from "@/jslibs/axios/http";

// 关于我们更新
export const edit = (data) => http.post("/v1/cms/aboutus", data);

// 关于我们详情
export const detail = (data) => http.get("/v1/cms/aboutus", data);
